import React from "react"
import DocumentDetails from "./DocumentDetails"
import OtherDocumentsSection from "./OtherDocumentsSection"
import gql from "graphql-tag"
import { graphql } from "@apollo/client/react/hoc"
import { Row, Col, Button, UncontrolledTooltip, Alert } from "reactstrap"
import Skeleton from "react-loading-skeleton"
import 'react-loading-skeleton/dist/skeleton.css'
import { cleanDocumentUrl } from "../../Material/DocumentModal/DocumentsListNew"
import { isImage } from "../../Material/DocumentModal/utils"
import withApolloClient from "../../withApolloClient"
import UploadIncidentDocumentModal from "../Components/UploadIncidentDocumentModal"
import DocumentModalNew from "../../Material/DocumentModal/DocumentModalNew"
import IncidentDocumentModal from "./IncidentDocumentModal/IncidentDocumentModal"
import IncidentDocumentLink from "../Components/IncidentDocumentLink"
import MoveIncidentDocumentModal from "../IncidentModals/MoveIncidentDocumentModal"
import { HasPermissionsQuery } from "../../Functions/querys"
import ConfirmationPopup from "../../Material/ConfirmationPopup"
import "./DocumentsTab.css"

const GENERATE_PDF = gql`mutation generatePdfFromImages($input: GeneratePDFFromImagesMutationInput!) {
  generatePdfFromImages(input: $input) {
    ok
    base64String
    errors { 
        messages
    }
  }
}`

const AllIncidentDocumentsQuery = gql`query AllIncidentDocuments($incidentId: ID!, $slug: String, $slugKey: [String], $isArchived: Boolean, $first: Int, $after: String) {
    allIncidentDocuments(incidentId: $incidentId, slug: $slug, slugKey: $slugKey, isArchived: $isArchived, first: $first, after: $after, orderBy: ["-date_modified"]) {
      edges {
        node {
          id
          pk
          slug
          dateAdded
          isArchived
          documentType{ 
            id 
            typeName: name
          }
          url
          document
          notes
          createdBy {
            id
            username
          }
        }
      }
      pageInfo{ 
        endCursor 
        hasNextPage 
      }
    }
}`

const IncidentBranchStateQuery = gql`
  query IncidentBranchStateQuery($incidentId: ID!) {
    incident(incidentId: $incidentId) {
      id
      branch {
        id
        stateCode
      }
    }
  }
`

const SendIncidentDarMv104RequestMutation = gql`
  mutation SendIncidentDarMv104RequestMutation($input: SendIncidentDarMv104RequestMutationInput!) {
    sendIncidentDarMv104Request(input: $input) {
      ok
      errors {
        messages
      }
    }
  }
`

class DocumentList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            documents: [],
            selectedDocument: null,
            selectedDocumentContext: null,
            selectedDocs: [],
            otherSelectableDocs: [],
            pdfBase64: null,
            error: null,
            successMessage: null,
            loading: false,
            actionMenuOpen: false,
            moveModalOpen: false,
            sendDarMv104Loading: false
        }
        this.actionsRef = React.createRef()
    }

    toggleSelectDoc = (doc) => {
        let selected = [...this.state.selectedDocs]
        const exists = selected.find(d => d.id === doc.id)

        if (exists) selected = selected.filter(d => d.id !== doc.id)
        else selected.push(doc)

        this.setState(prevState => ({
            selectedDocs: selected,
            actionMenuOpen: selected.length > 0 ? prevState.actionMenuOpen : false,
            moveModalOpen: selected.length > 0 ? prevState.moveModalOpen : false
        }))
    }

    getSelectableDocs = () => {
        const incidentDocs = this.props.showIncidentDocuments === false ? [] : (this.props.allIncidentDocuments?.edges || []).map(edge => edge.node)
        const showOtherDocumentsSection = this.props.showOtherDocumentsSection !== undefined ? this.props.showOtherDocumentsSection !== false : this.props.showInspectionSection !== false
        const otherDocs = showOtherDocumentsSection ? this.state.otherSelectableDocs || [] : []

        return [...incidentDocs, ...otherDocs]
    }

    setOtherSelectableDocs = (otherSelectableDocs = []) => {
        this.setState({ otherSelectableDocs })
    }

    toggleSelectAll = () => {
        const selectableDocs = this.getSelectableDocs()
        const selectedDocIds = new Set(this.state.selectedDocs.map(doc => doc.id))
        const nextDocs = [...this.state.selectedDocs]
        selectableDocs.forEach(doc => {
            if (!selectedDocIds.has(doc.id)) {
                nextDocs.push(doc)
            }
        })
        this.setState({ selectedDocs: nextDocs })
    }

    clearSelectedDocs = () => {
        this.setState({ selectedDocs: [], actionMenuOpen: false, moveModalOpen: false })
    }

    base64ToBlob = (base64) => {
        try {
            if (!base64 || typeof base64 !== "string")
                throw new Error("Invalid base64 input")

            const byteCharacters = atob(base64)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)

            return new Blob([byteArray], { type: "application/pdf" })
        } catch (e) {
            console.error("base64ToBlob failed: ", e)
            return null
        }
    }


    pdfHandler = async () => {
        const allImagesSelected = this.state.selectedDocs.length > 0
            && this.state.selectedDocs.every(doc => isImage(cleanDocumentUrl(doc.pictureUrl || doc.url), doc.document))
        if (!allImagesSelected) {
            this.setState({ error: "Select only images to download." })
            return
        }
        this.setState({ loading: true, error: null })
        const docs = this.state.selectedDocs.map(d => ({
            bucketPath: d.document && !d.pictureUrl ? d.document : null,
            imageUrl: d.pictureUrl || null,
            title: d.documentType?.typeName || "Document"
        }))
        try {
            const result = await this.props.apolloClient.mutate({
                mutation: GENERATE_PDF,
                variables: {
                    input: {
                        documents: docs,
                        imagesPerPage: 2
                    }
                }
            })
            if (result.data?.generatePdfFromImages?.ok) {
                const blob = this.base64ToBlob(result.data.generatePdfFromImages.base64String)
                if (!blob) {
                    this.setState({ error: "Failed to decode generated PDF.", loading: false })
                    return
                }
                if (this.state.pdfBase64) {
                    URL.revokeObjectURL(this.state.pdfBase64)
                }
                const pdfUrl = URL.createObjectURL(blob)
                this.setState({ pdfBase64: pdfUrl, loading: false, selectedDocs: [] })
            } else {
                this.setState({ error: "Failed to generate PDF.", loading: false })
            }
        } catch (err) {
            this.setState({ error: "An error occurred: " + err.message, loading: false })
        }
    };


    refetchQuery = () => {
        this.props.refetchDocumentsQuery && this.props.refetchDocumentsQuery()
    }

    viewDocuments = (documents, index = 0, context = {}) => {
        const nextContext = {
            objectType: "incident",
            isPicture: false,
            ...context,
        }
        documents = documents?.map(doc => ({
            documentUrl: cleanDocumentUrl(doc.node.pictureUrl || doc.node.documentUrl || doc.node.url || ""),
            id: doc.node.id,
            name: doc.node.pictureType || doc.node.documentType?.typeName || doc.node.document || doc.node.name,
            document: doc.node.document || doc.node.documentSlug || doc.node.name,
            documentType: doc.node.documentType || { typeName: doc.node.pictureType || doc.node.name || "Document" },
            description: doc.node.description || doc.node.notes,
            dateAdded: doc.node.dateAdded,
            isArchived: doc.node.isArchived,
            notes: doc.node.notes,
        }))
        this.setState({ documents: documents, selectedDocument: documents[index], selectedDocumentContext: nextContext })
    }
    next = () => {
        const documents = this.state.documents
        const currentIndex = documents.findIndex(item => item.id === this.state.selectedDocument.id)
        if (currentIndex === documents.length - 1) return
        this.setState({ selectedDocument: documents[currentIndex + 1] })
    }

    prev = () => {
        const documents = this.state.documents
        const currentIndex = documents.findIndex(item => item.id === this.state.selectedDocument.id)
        if (currentIndex === 0) return
        this.setState({ selectedDocument: documents[currentIndex - 1] })
    }

    componentDidUpdate(prevProps, prevState) {
        const prevCount = prevState.selectedDocs.length
        const nextCount = this.state.selectedDocs.length

        if (prevCount === 0 && nextCount > 0 && this.actionsRef.current) {
            requestAnimationFrame(() => {
                this.actionsRef.current?.scrollIntoView({ behavior: "smooth", block: "end" })
            })
        }

        if (prevCount > 0 && nextCount === 0 && (this.state.actionMenuOpen || this.state.moveModalOpen)) {
            // Close action menu/modals when selection is cleared.
            this.setState({ actionMenuOpen: false, moveModalOpen: false })
        }
    }

    toggleActionMenu = () => {
        this.setState(prevState => ({ actionMenuOpen: !prevState.actionMenuOpen }))
    }
    getDarMv104DocumentName = () => {
        if (this.props.incidentBranchLoading) return ""
        return (this.props.incidentBranchStateCode || "").toUpperCase() === "NY" ? "MV104" : "DAR"
    }

    sendDarMv104Request = async () => {
        let documentName = this.getDarMv104DocumentName()
        this.setState({ sendDarMv104Loading: true, error: null, successMessage: null })
        try {
            const result = await this.props.apolloClient.mutate({
                mutation: SendIncidentDarMv104RequestMutation,
                variables: {
                    input: {
                        incidentId: this.props.id
                    }
                }
            })

            const response = result?.data?.sendIncidentDarMv104Request
            if (response?.ok) {
                this.setState({
                    openModal: "",
                    sendDarMv104Loading: false,
                    error: null,
                    successMessage: `${documentName} request sent successfully.`
                })
                return
            }

            const error = response?.errors?.[0]?.messages?.join(", ") || `Failed to send ${documentName} request.`
            this.setState({ openModal: "", sendDarMv104Loading: false, error })
        } catch (err) {
            this.setState({
                openModal: "",
                sendDarMv104Loading: false,
                error: err.message || `Failed to send ${documentName} request.`
            })
        }
    }

    canSendDarMv104Document = () => {
        if (this.props.category !== "INCIDENT" || this.props.incidentBranchLoading) return false
        const isNyBranch = (this.props.incidentBranchStateCode || "").toUpperCase() === "NY"
        return isNyBranch ? this.props.hasPermissions?.includes("custom_can_send_mv104") : this.props.hasPermissions?.includes("custom_can_send_dar")
    }

    render() {
        const { loading, allIncidentDocuments, isArchived } = this.props
        const documentEdges = allIncidentDocuments?.edges || []
        const selectableDocs = this.getSelectableDocs()
        const selectedCount = this.state.selectedDocs?.length
        const selectedDocIds = new Set(this.state.selectedDocs.map(doc => doc.id))
        const allSelected = selectableDocs.length > 0 && selectableDocs.every(doc => selectedDocIds.has(doc.id))
        const hasDownloadableSelection = selectedCount > 0 && this.state.selectedDocs.every(doc => isImage(cleanDocumentUrl(doc.pictureUrl || doc.url), doc.document))
        const movableDocs = this.state.selectedDocs.filter(doc => !doc.pictureUrl)
        const isClaimCategory = ["CLAIM", "LIABILITY", "SUBROGATION"].includes(this.props.category)
        const canSelectDocuments = true
        const showDocumentActions = !isArchived && this.props.showDocumentActions !== false
        const canMove = showDocumentActions && !isClaimCategory && selectedCount > 0 && movableDocs.length === selectedCount
        const otherDocumentsCategory = this.props.otherDocumentsCategory || "inspection"
        const otherDocumentsCategoryId = this.props.otherDocumentsCategoryId || (otherDocumentsCategory === "inspection" ? this.props.id : null)
        const incidentDocumentPreviewContext = this.props.incidentDocumentPreviewContext || { objectType: "incident", isPicture: false }
        const isIncidentDocumentPreview = this.state.selectedDocumentContext?.isPicture === false
        const previewDocuments = this.state.documents || []
        const previewIndex = this.state.selectedDocument
            ? previewDocuments.findIndex(doc => doc.id === this.state.selectedDocument.id)
            : -1
        return (
            <>
                {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                {this.state.successMessage && <Alert color="success">{this.state.successMessage}</Alert>}
                {this.state.pdfBase64 &&
                    <DocumentModalNew
                        document={{
                            documentUrl: this.state.pdfBase64,
                            name: "Generated PDF"
                        }}
                        isPicture={true}
                        objectType="incident"
                        handleClose={() => {
                            URL.revokeObjectURL(this.state.pdfBase64)
                            this.setState({ pdfBase64: null })
                        }}
                    />
                }
                {(this.props.archiveFilterControl || showDocumentActions) && (
                    <div className="documents-toolbar-shell mb-4">
                        <div className="documents-toolbar-left">
                            {this.props.archiveFilterControl}
                        </div>
                        {showDocumentActions && (
                            <div className="documents-actions-bar">
                                <Button
                                    color="secondary"
                                    className="documents-action-btn documents-action-btn-primary"
                                    onClick={() => this.setState({ openModal: "uploadIncidentDocument" })}
                                    disabled={this.state.loading}
                                >
                                    Upload Document
                                </Button>
                                {!isClaimCategory && this.props.hasPermissions?.includes("custom_can_request_documents") && (
                                    <Button
                                        color="secondary"
                                        className="documents-action-btn documents-action-btn-secondary"
                                        onClick={() => this.setState({ openModal: "documentLinkModal" })}
                                        disabled={this.state.loading}
                                    >
                                        Request Missing Documents
                                    </Button>
                                )}
                                {this.canSendDarMv104Document() && (
                                    <Button
                                        color="secondary"
                                        className="documents-action-btn documents-action-btn-tertiary"
                                        onClick={() => this.setState({ openModal: "sendDarMv104Confirm", error: null, successMessage: null })}
                                        disabled={this.state.loading || this.state.sendDarMv104Loading}
                                    >
                                        {`Send ${this.getDarMv104DocumentName()}`}
                                    </Button>
                                )}
                            </div>
                        )}
                    </div>
                )}
                {showDocumentActions && <div>
                    {this.state.openModal === "sendDarMv104Confirm" && (
                        <ConfirmationPopup
                            open={this.state.openModal === "sendDarMv104Confirm"}
                            handleClose={() => this.setState({ openModal: "", sendDarMv104Loading: false })}
                            loading={this.state.sendDarMv104Loading}
                            action={`Send ${this.getDarMv104DocumentName()}`}
                            color="primary"
                            message={`Are you sure you want to send ${this.getDarMv104DocumentName()} document?`}
                            confirmAction={this.sendDarMv104Request}
                        />
                    )}
                    {this.state.openModal === "documentLinkModal" &&
                        <IncidentDocumentLink
                            incidentId={this.props.id}
                            isOpen={this.state.openModal === "documentLinkModal"}
                            toggle={() => this.setState({ openModal: "" })}
                            category={this.props.category || ""}
                            slug={this.props.slug}
                        />
                    }
                    {this.state.openModal === "uploadIncidentDocument" && (
                        <UploadIncidentDocumentModal
                            incidentId={this.props.id}
                            isOpen={this.state.openModal === "uploadIncidentDocument"}
                            toggle={() => this.setState({ openModal: "" })}
                            refetchQuery={this.props.refetchDocumentsQuery}
                            documentCategory={this.props.category || ""}
                            slug={this.props.slug}
                            requireTargetSelection={this.props.requireTargetSelection === true}
                        />
                    )}
                </div>}
                {loading && <Row>
                    {[...Array(10)].map((_, index) => (
                        <Col className="mt-3" xs={4} key={index}>
                            <Skeleton count={1} height={50} />
                        </Col>
                    ))}
                </Row>}
                {this.state.selectedDocument && (isIncidentDocumentPreview ? (
                    // Incident documents get their own viewer. Pictures and the generated
                    // PDF stay on DocumentModalNew: neither is an IncidentDocument row, so
                    // neither has an id the new modal could fetch.
                    <IncidentDocumentModal
                        documentId={this.state.selectedDocument.id}
                        isOpen={true}
                        toggle={() => this.setState({ selectedDocument: null })}
                        onChanged={this.props.refetchDocumentsQuery}
                        onPrev={previewIndex > 0 ? this.prev : undefined}
                        onNext={previewIndex > -1 && previewIndex < previewDocuments.length - 1 ? this.next : undefined}
                        positionLabel={previewDocuments.length > 1 ? `Document ${previewIndex + 1} of ${previewDocuments.length}` : ""}
                    />
                ) : (
                    <DocumentModalNew
                        document={this.state.selectedDocument}
                        handleClose={() => this.setState({ selectedDocument: null })}
                        next={this.next}
                        prev={this.prev}
                        objectType={this.state.selectedDocumentContext?.objectType || "incident"}
                        isPicture={this.state.selectedDocumentContext?.isPicture ?? false}
                        refetch={this.state.selectedDocumentContext?.refetch || this.props.refetchDocumentsQuery}
                        currentUser={this.props.currentUser}
                        driverId={this.state.selectedDocumentContext?.driverId || null}
                        documentCategory={this.props.category || ""}
                    />
                ))}
                {this.props.showIncidentDocuments !== false && (
                    <div className="DocumentCardContainer">
                        {!loading && documentEdges.length > 0 ? (documentEdges.map((document, idx) => (
                            <DocumentDetails
                                key={`incident-doc-${idx}`}
                                document={document.node}
                                ownerLabel={this.props.documentOwnerMap?.[document.node.slug] || null}
                                viewDocuments={() => this.viewDocuments(documentEdges, idx, incidentDocumentPreviewContext)}
                                refetchQuery={this.props.refetchDocumentsQuery}
                                toggleSelectDoc={this.toggleSelectDoc}
                                isLoading={this.state.loading}
                                isSelected={!!this.state.selectedDocs.find(d => d.id === document.node.id)}
                                showSelectCheckbox={canSelectDocuments}
                                showEditChip={showDocumentActions}
                                viewType={this.props.viewType}
                                incidentId={this.props.id}
                            />
                        ))) : !loading && (
                            <div className="documents-empty-state-wrap">
                                <div className="documents-empty-state">
                                    <span className="documents-empty-state__icon">
                                        <i className="fa fa-folder-open-o" aria-hidden="true" />
                                    </span>
                                    <h3 className="documents-empty-state__title mb-0">No Documents Yet</h3>
                                    <p className="documents-empty-state__description">
                                        Upload documents or request missing ones to keep this section complete.
                                    </p>
                                </div>
                            </div>
                        )
                        }
                        {!loading && allIncidentDocuments?.pageInfo?.hasNextPage && (
                            <div className="w-100 text-right mt-3">
                                <Button
                                    color="primary"
                                    size="sm"
                                    disabled={this.state.loading}
                                    onClick={() => { this.props.loadMoreEntries && this.props.loadMoreEntries() }}
                                >
                                    Load More
                                </Button>
                            </div>
                        )}
                    </div>
                )}
                {(this.props.showOtherDocumentsSection !== undefined ? this.props.showOtherDocumentsSection !== false : this.props.showInspectionSection !== false) && this.props.viewType === "incident" && (
                    <OtherDocumentsSection
                        documentCategory={otherDocumentsCategory}
                        categoryId={otherDocumentsCategoryId}
                        loading={loading || this.state.loading}
                        selectedDocs={this.state.selectedDocs}
                        onToggleSelect={this.toggleSelectDoc}
                        onSelectableDocsChange={this.setOtherSelectableDocs}
                        onPreview={(documents, idx, context) => this.viewDocuments(documents, idx, context)}
                    />
                )}
                {
                    canSelectDocuments && selectedCount > 0 && (
                        <div className="incident-actions-container" ref={this.actionsRef}>
                            <div className="incident-actions-stack">
                                {this.state.actionMenuOpen && (
                                    <>
                                        <Button className={`floating-btn select-all-btn ${selectedCount > 0 ? "has-selection" : ""}`} id="unselect-btn" color="info" onClick={this.clearSelectedDocs} disabled={this.state.loading}>
                                            <>
                                                <span className="select-count">{selectedCount}</span>
                                                <span className="select-clear" aria-hidden="true">
                                                    <i className="fa fa-times" />
                                                </span>
                                            </>
                                        </Button>
                                        <UncontrolledTooltip target="unselect-btn" placement="top">
                                            Unselect All Documents
                                        </UncontrolledTooltip>
                                        {selectableDocs.length > 0 && !allSelected && <>
                                            <Button className="floating-btn" id="select-all-menu-btn" color="info" onClick={this.toggleSelectAll} disabled={this.state.loading}>
                                                <i className="fa fa-check-square-o" />
                                            </Button>
                                            <UncontrolledTooltip target="select-all-menu-btn" placement="top">
                                                Select All Documents
                                            </UncontrolledTooltip>
                                        </>
                                        }

                                        {showDocumentActions && !isClaimCategory && (
                                            <>
                                                <Button className="floating-btn" id="move-btn" color="warning" onClick={() => this.setState({ moveModalOpen: true })} disabled={!canMove || this.state.loading}>
                                                    <i className="fa fa-exchange" />
                                                </Button>
                                                <UncontrolledTooltip target="move-btn" placement="top">
                                                    {canMove ? "Move Document" : "Select incident documents only for move feature"}
                                                </UncontrolledTooltip>
                                            </>
                                        )}
                                        <Button className="floating-btn" id="download-btn" color="success" onClick={this.pdfHandler} disabled={this.state.loading || !hasDownloadableSelection}>
                                            {this.state.loading ? <div className="spinner-border spinner-border-sm" /> : <i className="fa fa-download" />}
                                        </Button>
                                        <UncontrolledTooltip target="download-btn" placement="top">
                                            {hasDownloadableSelection ? "Download Selected as PDF" : "Select only images to download"}
                                        </UncontrolledTooltip>
                                    </>
                                )}
                                <Button className="floating-btn" id="actions-btn" style={{ background: "#303e67" }} onClick={this.toggleActionMenu} disabled={this.state.loading}>
                                    <i className="fa fa-ellipsis-v" />
                                </Button>
                                <UncontrolledTooltip target="actions-btn" placement="top">Actions</UncontrolledTooltip>
                            </div>
                        </div>
                    )}
                {canMove && (
                    <MoveIncidentDocumentModal
                        isOpen={this.state.moveModalOpen}
                        onClose={() => this.setState({ moveModalOpen: false })}
                        onMoved={() => this.setState({ selectedDocs: [], moveModalOpen: false, actionMenuOpen: false })}
                        incidentId={this.props.id}
                        documents={movableDocs}
                        viewType={this.props.viewType}
                        currentCategory={this.props.category}
                        refetch={this.props.refetchDocumentsQuery}
                    />
                )
                }
            </>
        )
    }
}

export default withApolloClient(
    graphql(AllIncidentDocumentsQuery, {
        skip: ({ showIncidentDocuments }) => showIncidentDocuments === false,
        options: ({ id, isArchived, slug, slugKey }) => ({
            variables: { incidentId: id, slug, slugKey, isArchived, first: 5 },
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true,
        }),
        props({ data: { allIncidentDocuments, loading, refetch, fetchMore, variables } }) {
            return {
                loading,
                allIncidentDocuments,
                variables,
                refetch,
                refetchDocumentsQuery: () =>
                    fetchMore({
                        query: AllIncidentDocumentsQuery,
                        variables: { ...variables, first: 5 },
                        updateQuery: (_, { fetchMoreResult }) => {
                            const newEdges = fetchMoreResult?.allIncidentDocuments?.edges || []
                            const pageInfo = fetchMoreResult?.allIncidentDocuments?.pageInfo
                            return {
                                allIncidentDocuments: {
                                    edges: [...newEdges],
                                    pageInfo,
                                    __typename: "AllIncidentDocuments"
                                }
                            }
                        }
                    }),
                loadMoreEntries: () =>
                    fetchMore({
                        query: AllIncidentDocumentsQuery,
                        variables: {
                            after: allIncidentDocuments.pageInfo.endCursor,
                            ...variables
                        },
                        updateQuery: (prev, { fetchMoreResult }) => {
                            const newEdges = fetchMoreResult?.allIncidentDocuments?.edges || []
                            const pageInfo = fetchMoreResult?.allIncidentDocuments?.pageInfo
                            return {
                                allIncidentDocuments: {
                                    edges: [...prev.allIncidentDocuments.edges, ...newEdges],
                                    pageInfo,
                                    __typename: prev.allIncidentDocuments.__typename
                                }
                            }
                        }
                    })
            }
        }
    })(
        graphql(IncidentBranchStateQuery, {
            skip: ({ showDocumentActions }) => showDocumentActions === false,
            options: ({ id }) => ({
                variables: { incidentId: id },
                fetchPolicy: "network-only",
            }),
            props({ data: { incident, loading } }) {
                return {
                    incidentBranchLoading: loading,
                    incidentBranchStateCode: incident?.branch?.stateCode || null,
                }
            }
        })(
            graphql(HasPermissionsQuery, {
                skip: ({ showDocumentActions }) => showDocumentActions === false,
                options: {
                    variables: {
                        userPermissions: ["custom_can_request_documents", "custom_can_send_dar", "custom_can_send_mv104"],
                    },
                },
                props({ data: { hasPermissions, variables } }) {
                    return {
                        hasPermissions,
                        variables,
                    }
                },
            })(DocumentList)
        )
    )
)
